export const environment = {
  production: true,
  managirUrl: "/managir/api/v1",
  imagesUrl: "/managir/images",
  agirUrl: window.location.origin,
  socketUrl: window.location.origin,
  socketPath: "/managir/socket.io",
};



// WEBPACK FOOTER //
// /agir/src/environments/environment.ts